module.exports = __webpack_public_path__ + "media/components/common/images/rdc-8ececec7faddc9f67474f6ead9b5c132.png";